import gql from 'graphql-tag'
import storyCardFragment from '@schema/story-card'

const storyFragment = `
${storyCardFragment}
tagsCollection {
  items {
    label
  }
}
`

export const COACH_JOURNEY_QUERY = gql`
  query CoachPersonaPage($preview: Boolean) {
    coachLandingPersonaDrivenCollection(limit: 1, preview: $preview) {
      items {
        title
        metaTitle
        metaDescription
        metaImage {
          url
        }
        headline
        subtitle
        personaSegmentHeadline
        personaSegmentText
        personaSegmentCardsCollection {
          items {
            media {
              url
              description
            }
            headline
            link
          }
        }
        relatedArticlesTitle
        relatedArticlesText
        relatedArticlesCta
        relatedArticlesCollection {
          items {
            ${storyFragment}
          }
        }
      }
    }
  }
`
